/**
 * Also fix for the absent console in IE9
 */
if (!window.console)
{
    window.console = {};
    window.console.log = window.console.assert = function(){};
    window.console.warn = window.console.assert = function(){};
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/phaser-plugin-scene-watcher/node_modules/phaser/src/polyfills/console.js
// module id = 2064
// module chunks = 0